import { FormFieldV2 } from '@/components/custom/erp';
import { Label } from '@/components/ui/label';
import { FormMode } from '@/types/form';

interface BasicFormProps {
  formMode: FormMode;
}

const BasicForm: React.FC<BasicFormProps> = ({ formMode }) => {
  const isViewMode = formMode === 'view';

  return (
    <div className='flex flex-col gap-y-2 p-4'>
      <div className='flex items-center'>
        <Label className='min-w-36 font-medium' required>
          Mã ngân hàng
        </Label>
        <FormFieldV2 type='text' name='ma_ngan_hang' disabled={formMode === 'view' || formMode === 'edit'} />
      </div>

      <div className='flex items-center'>
        <Label className='min-w-36 font-medium' required>
          Tên ngân hàng
        </Label>
        <div className='w-full'>
          <FormFieldV2 type='text' name='ten_ngan_hang' disabled={isViewMode} />
        </div>
      </div>

      <div className='flex items-center'>
        <Label className='min-w-36 font-medium' required>
          Tên khác
        </Label>
        <div className='w-full'>
          <FormFieldV2 type='text' name='ten_ngan_hang2' disabled={isViewMode} />
        </div>
      </div>

      <div className='flex items-center'>
        <Label className='min-w-36 font-medium' required>
          Mã số
        </Label>
        <FormFieldV2 type='text' name='ma_so' disabled={isViewMode} />
      </div>

      <div className='flex items-center'>
        <Label className='min-w-36 font-medium' required>
          Trạng thái
        </Label>
        <div className='w-full'>
          <FormFieldV2
            type='select'
            name='status'
            className='w-full'
            disabled={isViewMode}
            options={[
              { value: 1, label: '1. Còn sử dụng' },
              { value: 0, label: '0. Không sử dụng' }
            ]}
          />
        </div>
      </div>
    </div>
  );
};

export default BasicForm;
